import { render, staticRenderFns } from "./chartVisitorMonths.vue?vue&type=template&id=64953170&scoped=true&"
import script from "./chartVisitorMonths.vue?vue&type=script&lang=js&"
export * from "./chartVisitorMonths.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "64953170",
  null
  
)

export default component.exports